module.exports = __webpack_public_path__ + "static/media/AtRisk.2e8693a0.svg";